import React from 'react'
import { Link } from 'react-router-dom'
import { fileUrl } from '../../functions/fileUrl'
import { LABELS } from '../../constants/staticText'
import VisuallyHidden from '../../../lib/a11y/VisuallyHidden'
import { Ueberschrift } from '../../../lib/a11y/Ueberschrift'
import { bildMasse } from '../../../lib/functions/bildMasse'
import ExhibitorProfileLink from '../../../lib/components/ExhibitorProfileLink'

// Aufbau 1:1 wie auf der Live-Seite (scss/live/blocks-aussteller.css): eine Zeile
// über die volle Breite — Name mit Praktikum-Abzeichen links, Logo rechts,
// darunter die Berufe als Aufzählung, abgeschlossen von einer Trennlinie.
// Das Abzeichen speist sich aus participants.internship, der Abschnitt
// „Praktikumsplätze“ dagegen aus dem Angebotstyp (Spec 4.3).
const professionName = (profession) =>
    profession.specialization ? `${profession.title} ${profession.specialization}` : profession.title

// Der Beruf führt in die Themen-Kachel derselben Messe. Ohne diese Kachel gibt
// es kein Ziel — dann bleibt der Beruf Text statt eines Verweises ins Leere (#53).
// LinkComponent wie bei EventCard (#107): im Router die Route, im Shortcode
// ein gewöhnlicher <a> (#177).
const Profession = ({ profession, themesPath, LinkComponent }) => themesPath
    ? <LinkComponent to={`${themesPath}#beruf-${profession.id}`}>{professionName(profession)}</LinkComponent>
    : professionName(profession)

const ExhibitorCard = ({ exhibitor, themesPath = null, LinkComponent = Link }) => (
    <article className="exhibitor-card" id={`aussteller-${exhibitor.participantId}`}>
        <header className="exhibitor-card-head">
            <Ueberschrift className="exhibitor-card-name">
                <ExhibitorProfileLink id={exhibitor.participantId}>{exhibitor.name}</ExhibitorProfileLink>
            </Ueberschrift>
            {exhibitor.internship && <span className="exhibitor-card-internship">(Praktikum möglich)</span>}
        </header>

        <div className="exhibitor-card-logo">
            {exhibitor.logo && (
                exhibitor.website
                    ? <a href={exhibitor.website} target="_blank" rel="noreferrer">
                        <img src={fileUrl(exhibitor.logo.fileId)} alt={exhibitor.name} loading="lazy" decoding="async" {...bildMasse(exhibitor.logo)} />
                        <VisuallyHidden>{LABELS.opensNewTab}</VisuallyHidden>
                    </a>
                    : <img src={fileUrl(exhibitor.logo.fileId)} alt={exhibitor.name} loading="lazy" decoding="async" {...bildMasse(exhibitor.logo)} />
            )}
        </div>

        <ul className="exhibitor-card-professions">
            {exhibitor.professions.map(profession => (
                <li key={profession.id}>
                    <Profession profession={profession} themesPath={themesPath} LinkComponent={LinkComponent} />
                </li>
            ))}
        </ul>

        {/* Die Anzeigen der Firma liegen in einer eigenen App auf einer eigenen
            WordPress-Seite — darum ein echter Verweis, keine Router-Navigation.
            Ohne Anzeigen entfällt er, statt auf eine leere Liste zu führen (#53). */}
        {exhibitor.jobCount > 0 && (
            <a className="exhibitor-card-jobs" href={`/stellenangebote/?company=${exhibitor.participantId}`}>
                {LABELS.exhibitorJobs} ({exhibitor.jobCount})
            </a>
        )}
    </article>
)

export default ExhibitorCard
